export namespace Routes {
  export const home = '/';
  export const feature = (uid: string) => `/feature/${uid}`;
  export const industry = (uid: string) => `/industry/${uid}`;
  export const demo = (uid: string) => `/demo/${uid}`;
  export const aboutUs = '/about';
  export const getStarted = '/get-started';
  export const getInTouch = '/get-in-touch';
}
